import moment from 'moment';

export default {
    localizedDate(value, format) {
        if(!value) {
            return '';
        }
        value = value.toString();
        return moment(value).format(format);
    }
};



// WEBPACK FOOTER //
// ./src/filters/DateFilters.js